import { Directive } from '@angular/core';


/**
 * Prefix to be placed the front of the {@link TsFormFieldComponent}
 */
@Directive({ selector: '[tsPrefix]' })
export class TsPrefixDirective {}
